up.$compiler('[clickable-row]', ($element) => {
  $element.on('click', (event) => {
    if ($(event.target).closest('a, [checkable-cell]').length > 0) {
      // User clicked directly on a link or interactable table cell
      return
    }

    let $anchor = $element.find(`${'a'}:first`)

    if ($anchor.is('[up-layer]')) {
      up.follow($anchor, { layer: 'new' })
    } else if ($anchor.is('[up-target]')) {
      up.follow($anchor)
    } else if ($anchor.length > 0) {
      $anchor.get(0).click()
    }
  })
})
